import { createSlice } from "@reduxjs/toolkit";
import { addNewLotteryBrand, editLotteryBrand, getAllLotteryBrands } from "./lotteryBrandService";

const initialState = {
  allLotteryBrands: {
    isLotteriesLoading: null,
    isLotteriesSuccess: null,
    lotteriesMessage: null,
    pageCount: 0,
    lotteries: [],
  },
  newLotteryBrand: {
    isLotteryCreating: null,
    isLotteryCreated: null,
    lotteryCreationMsg: null,
  },
  editedLotteryBrand: {
    isEditingLotteryBrand: null,
    isLotteryBrandEdited: null,
    lotteryBrandEditedMsg: null,
  },
};

const lotteriesSlice = createSlice({
  name: "lottery",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllLotteryBrands.pending, (state) => {
        state.allLotteryBrands = {
          ...initialState.allLotteryBrands,
          isLotteriesLoading: true,
          lotteriesMessage: "Loading",
        };
      })

      // REJECTED
      .addCase(getAllLotteryBrands.rejected, (state, action) => {
        state.allLotteryBrands = {
          ...initialState.allLotteryBrands,
          isLotteriesLoading: false,
          isLotteriesSuccess: false,
          lotteriesMessage:
            action.payload || "Error occurred while fetching lottery brands",
        };
      })

      // FULFILLED
      .addCase(getAllLotteryBrands.fulfilled, (state, action) => {
        state.allLotteryBrands = {
          ...initialState.allLotteryBrands,
          isLotteriesLoading: false,
          isLotteriesSuccess: true,
          pageCount: action.payload.pageCount || 0,
          lotteries: action.payload || [],
        };
      });

    //Lottery creating
    builder
      .addCase(addNewLotteryBrand.pending, (state) => {
        state.newLotteryBrand = {
          ...initialState.newLotteryBrand, 
          isLotteryCreating: true,
          lotteryCreationMsg: "Loading",
        };
      })

      // REJECTED
      .addCase(addNewLotteryBrand.rejected, (state, action) => {
        state.newLotteryBrand = {
          ...initialState.newLotteryBrand,
          isLotteryCreating: false,
          isLotteryCreated: false,
          lotteryCreationMsg:
            action.payload || "Error occurred while creating the lottery brand.",
        };
      })

      // FULFILLED
      .addCase(addNewLotteryBrand.fulfilled, (state, action) => {
        state.newLotteryBrand = {
          ...initialState.newLotteryBrand,
          isLotteryCreating: false,
          isLotteryCreated: true,
          lotteryCreationMsg: action.payload || "Successfully created the lottery brand.",
        };
      });

       //Lottery editing
    builder
    .addCase(editLotteryBrand.pending, (state) => {
      state.editedLotteryBrand = {
        ...initialState.editedLotteryBrand, 
        isEditingLotteryBrand: true,
        lotteryBrandEditedMsg: "Loading",
      };
    })

    // REJECTED
    .addCase(editLotteryBrand.rejected, (state, action) => {
      state.editedLotteryBrand = {
        ...initialState.editedLotteryBrand, 
        isEditingLotteryBrand: false,
        isLotteryBrandEdited: false,
        lotteryBrandEditedMsg:
          action.payload || "Error occurred while editing the lottery brand.",
      };
    })

    // FULFILLED
    .addCase(editLotteryBrand.fulfilled, (state, action) => {
      state.editedLotteryBrand = {
        ...initialState.editedLotteryBrand, 
        isEditingLotteryBrand: false,
        isLotteryBrandEdited: true,
        lotteryBrandEditedMsg: action.payload || "Successfully edited the lottery brand.",
      };
    });
  },
});

export default lotteriesSlice.reducer;
